import { UISchema } from "@bonusmap/api-types";

export async function retrieveCategories(dataSource: UISchema,
    fieldName: string = "categories"): Promise<string[]> {
    // recupera gli ids delle categorie dal dataSource come in helper-ambito_territoriale.ts
    const uiField = dataSource[fieldName];
    if (!uiField) {
        return [];
    }
    const ids = uiField.value;
    if (!ids) {
        return [];
    }
    // controlla se ids è già un array di stringhe
    if (Array.isArray(ids) && ids.length > 0 && typeof ids[0] === 'string') {
        // è già un array di stringhe
        return ids as string[];
    }
    let valueArray: number[] = [];
    if (!Array.isArray(ids)) {
        // singolo id
        const singleId = ids as number;
        valueArray = [singleId];
    } else {
        // array di id
        valueArray = ids as number[];
    }
    const result = await   window.api.manager.categories.getByIds(valueArray);
    if (!result?.success || !result?.data) {
        return [];
    }
    const valueArrayStr = result.data.map(item => item.title || "").filter(title => title !== "");
    return valueArrayStr as string[];
}